module.exports = __webpack_public_path__ + "static/media/kv_folded_fully_compressed.df0a7285.webp";